var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('b-spinner',{attrs:{"label":_vm.$t('loading'),"small":_vm.small}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }